/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import './RoqqDialogDivider.css';

export default function RoqqDialogDivider({ margin, classNames }) {
  return (
    <hr style={{ margin }} className={`roqqu-dialog-divider ${classNames}`} />
  );
}
